import { Bold, Flex } from './TremorCompat';
import { IconButton, Panel, Text } from 'rsuite';
import { RxReset as IconReset } from 'react-icons/rx';

import { DisplayIcon } from './DisplayIcon';

export const DisplayItemWithReset = ({ register, tc, icon, borderOff, onChange, disabled }) => {
  return (
    <Panel bordered={!borderOff} style={{ backgroundColor: 'white' }}>
      <Flex justifyContent="start" className="space-x-4">
        {/* <FlexboxGrid.Item as={Col} colspan={24} md={6}> */}
        <DisplayIcon icon={icon} />

        <div
          className="truncate space-y-0.5 w-1/4"
          style={{
            display: 'block',
            width: '50%',
          }}
        >
          <Text color={tc}>{register.title}</Text>
          <Text>
            <Bold>{register.display}</Bold>
          </Text>
        </div>
        <div
          className="truncate w-1/2 space-y-1"
          style={{
            display: 'block',
            width: '50%',
          }}
        >
          <Flex justifyContent="end" className="space-x-4 ">
            <IconButton
              appearance="primary"
              color="blue"
              size="sm"
              icon={<IconReset />}
              onClick={() => onChange(register, 0xffff)}
              disabled={disabled}
              aria-label={`Reset ${register.title}`}
            />
          </Flex>
        </div>
      </Flex>
    </Panel>
  );
};
